import { object, string } from "zod/v4";

export const productContextSchema = object({
  productId: string(),
  variantId: string().optional(),
});

export const contextSchema = object({
  product: productContextSchema.optional(),
});
